import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { WIDGET_AUTH_INTEGRATION_STORAGE_KEY } from 'constants/widgetIntegrationBranding';

/**
 * When the user signed in via the auth widget, the calendar must stay on that
 * integration's provider. Returns null when not in that flow or data is missing.
 */
export function useWidgetAuthLockedProvider() {
  const integration = useSelector(state => state.widget?.integration);

  return useMemo(() => {
    let idStr;
    try {
      idStr = sessionStorage.getItem(WIDGET_AUTH_INTEGRATION_STORAGE_KEY);
    } catch {
      return null;
    }
    if (!idStr || !integration?.data) {
      return null;
    }
    const idNum = parseInt(idStr, 10);
    const apiId = parseInt(integration.data.id, 10);
    if (Number.isNaN(idNum) || Number.isNaN(apiId) || apiId !== idNum) {
      return null;
    }
    const pid = integration.data.providerId ?? integration.data.provider?.id;
    if (pid == null) {
      return null;
    }
    return String(pid);
  }, [integration]);
}
